// extracted by mini-css-extract-plugin
export default {"container":"Select--container--Krxee","avatar":"Select--avatar--YN9aw"};